import Panel from './panel';
import { tagOnClick, wrapLink } from '../utils';

export default class TermsPanel extends Panel {
  render() {
    tagOnClick(this.getTag('back-button'), () => {
      this.parent.transitionToPanel('share');
    });

    const agree = this.getTag('agree');
    if (agree) {
      wrapLink(agree.element, { className: 'link-wrapper', target: '_blank' });
    }
  }

  activate() {
    const agree = this.getTag('agree');

    if (agree) {
      const link = agree.element.querySelector('a');
      if (link) {
        link.href = this.parent.shareURL;
      }
    }
  }
}
